<template>
    <div class="elle-path-list">
        <div class="container">
            <div class="list">
                <div v-for="item in items" :key="item.id" ref="$rows" class="row">
                    <div class="period">
                        <div class="day">{{ item?.day }}</div>
                        <div v-show="item?.prefix" class="prefix">{{ item?.prefix }}</div>
                    </div>
                    <div class="description">
                        <div class="label">{{ item?.headline }}</div>
                        <div class="content typography" v-html="item?.body" />

                        <div v-if="!!item.linkUrl.length && !item.linkUrl[0].isEmpty" class="links">
                            <UiLink v-if="item.linkUrl[0].isEmpty == false" :link="item.linkUrl[0]" :style="'transparent w-border'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    items: {
        type: Array,
        default: () => []
    }
});

const $rows = ref([]);

onMounted(() => {
    if ($rows.value.length) {
        $rows.value.forEach((el, index) => {
            if (props.items[index].media.length) {
                el.dataset.media = props.items[index].media[0].webp;
                new reveralImage(el);
            }
        });
    }
});
</script>
